import { useTranslation } from "react-i18next";
import { ArrowDown, ArrowUp } from "iconsax-react";
import { Select } from "@/shared/ui";
import type { ProjectSortOption } from "../../../hooks/useProjectsPage";

interface Props {
  totalResults: number;
  sortBy: ProjectSortOption;
  onSortChange: (value: ProjectSortOption) => void;
}

export default function ProjectsToolbar({ totalResults, sortBy, onSortChange }: Props) {
  const { t } = useTranslation("ProjectsPage");

  const sortOptions: { label: string; value: ProjectSortOption; icon: React.ReactNode }[] = [
    { label: t("toolbar.defaultSort"), value: "default", icon: <ArrowDown size={16} color="currentColor" /> },
    { label: t("toolbar.sort.nameAsc"), value: "name_asc", icon: <ArrowUp size={16} color="currentColor" /> },
    { label: t("toolbar.sort.nameDesc"), value: "name_desc", icon: <ArrowDown size={16} color="currentColor" /> },
    { label: t("toolbar.sort.budgetDesc"), value: "budget_desc", icon: <ArrowDown size={16} color="currentColor" /> },
    { label: t("toolbar.sort.budgetAsc"), value: "budget_asc", icon: <ArrowUp size={16} color="currentColor" /> },
    { label: t("toolbar.sort.dateDesc"), value: "date_desc", icon: <ArrowDown size={16} color="currentColor" /> },
    { label: t("toolbar.sort.dateAsc"), value: "date_asc", icon: <ArrowUp size={16} color="currentColor" /> },
  ];

  return (
    <div className="flex items-center justify-between gap-3 mb-5">
      <Select
        options={sortOptions}
        value={sortBy}
        onChange={(val) => {
          if (val) onSortChange(val);
        }}
        width="w-48"
      />

      <div className="flex justify-end items-center gap-3">
        <p className="text-label-sm content-action-neutral">
          <span className="content-base-primary">{totalResults}</span> {t("toolbar.results")}
        </p>
      </div>
    </div>
  );
}
